import styled from 'styled-components';

export const StyledSeriesResultsInfoText = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;
